import { post, get } from '../axios'

// queryCountryInfo
export function common_queryCountryInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMON}/common/queryCountryInfo`,
    map,
    option
  ).then(response => response)
}

// queryLanguageInfo
export function common_queryLanguageInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMON}/common/queryLanguageInfo`,
    map,
    option
  ).then(response => response)
}

// querySiteInfo
export function common_querySiteInfo_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMON}/common/querySiteInfo`,
    map,
    option
  ).then(response => response)
}

// querySiteInfo
export function common_querySiteInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMON}/common/querySiteInfo`,
    map,
    option
  ).then(response => response)
}

// queryStateInfo
export function common_queryStateInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMON}/common/queryStateInfo`,
    map,
    option
  ).then(response => response)
}

// uploadFile
export function common_uploadFile_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMON}/common/uploadFile`,
    map,
    option
  ).then(response => response)
}

// listLanguageInfo
export function common_listLanguageInfo_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMON}/common/listLanguageInfo`,
    map,
    option
  ).then(response => response)
}
